import Flickity from 'flickity';

const initCarousel = (element) => {
    const carouselEl = element.querySelector('.js-carousel');

    const options = {
        autoPlay: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: false,
        contain: true
    };

    const carousel = new Flickity(carouselEl, options);

    const prevBtn = element.querySelector('.js-prev');
    const nextBtn = element.querySelector('.js-next');

    prevBtn.addEventListener('click', () => {
        carousel.previous(true, false);
    });

    nextBtn.addEventListener('click', () => {
        carousel.next(true, false);
    });

    setTimeout(() => {
        carousel.resize();
    }, 250);
}

export { initCarousel as default };